<template>
	<div
		ref="pageWrapper"
		class="page-wrapper d-flex flex-column"
		:class="{ 'd-none': !isReady, 'scroll-up': isScrollingUp, 'scroll-down': isScrollingDown }"
	>
		<LandingV6Top
			class="landing-page-component"
			@register="registerByEvent('creator-store')"
			id="creator-store"
			:activeComponent="visibleComponentId === 'creator-store'"
		/>
		<LandingV6Showcase
			class="landing-page-component"
			@register="registerByEvent('creators-showcase')"
			id="creators-showcase"
			:activeComponent="visibleComponentId === 'creators-showcase'"
		/>
		<LandingV6Testimonials
			class="landing-page-component"
			@register="registerByEvent('people-saying')"
			id="people-saying"
			:activeComponent="visibleComponentId === 'people-saying'"
		/>
		<LandingV6Features
			class="landing-page-component"
			@register="registerByEvent('product-highlights')"
			id="product-highlights"
			:activeComponent="visibleComponentId === 'product-highlights'"
		/>
		<LandingV6ProductPerks
			class="landing-page-component"
			@register="registerByEvent('competitors')"
			id="competitors"
			:activeComponent="visibleComponentId === 'competitors'"
		/>
		<LandingV6SetupSteps
			class="landing-page-component"
			@register="registerByEvent('setup')"
			id="setup"
			:activeComponent="visibleComponentId === 'setup'"
		/>
		<LandingV6Footer id="footer" class="" />
	</div>
</template>

<script>
	import { defineComponent, getCurrentInstance, inject, onMounted, nextTick, onUnmounted, ref, watch } from 'vue'
	import LandingV6Showcase from '@/components/home/V6/LandingV6Showcase'
	import LandingV6Top from '@/components/home/V6/LandingV6Top'
	import LandingV6Testimonials from '@/components/home/V6/LandingV6Testimonials'
	import LandingV6Features from '@/components/home/V6/LandingV6Features'
	import LandingV6ProductPerks from '@/components/home/V6/LandingV6ProductPerks'
	import LandingV6SetupSteps from '@/components/home/V6/LandingV6SetupSteps'
	import LandingV6Footer from '@/components/footer/FooterV6'
	import { getIsMobile, isInView } from '@/plugins/is'

	const callToActionButton = {
		'creator-store': {
			text: 'Create Your Store',
			background: '#FFFFFF',
			color: '#142658',
		},
		'product-highlights': {
			text: 'Create Your Store',
			background: '#142658',
			color: '#FFFFFF',
		},
		'creators-showcase': {
			text: 'Create Your Store',
			background: '#142658',
			color: '#FFFFFF',
		},
		'people-saying': {
			text: 'People saying',
			background: '#142658',
			color: '#FFFFFF',
		},
		competitors: {
			text: 'Try Stan 14 Days Free',
			background: '#142658',
			color: '#FFFFFF',
		},
		setup: {
			text: 'Try Stan 14 Days Free',
			background: '#142658',
			color: '#FFFFFF',
		},
	}

	export default defineComponent({
		name: 'LandingPageV6',
		components: {
			LandingV6Top,
			LandingV6Showcase,
			LandingV6Testimonials,
			LandingV6Features,
			LandingV6ProductPerks,
			LandingV6SetupSteps,
			LandingV6Footer,
		},
		setup() {
			const urlParams = new URLSearchParams(window.location.search)
			const myParam = urlParams.get('myParam')

			const handleScroll = () => {
				const st = window.pageYOffset || document.documentElement.scrollTop
				if (st > lastScrollTop.value) {
					document.body.classList.remove('scroll-up')
					document.body.classList.remove('scroll-about')
					document.body.classList.add('scroll-down')
				} else if (st < lastScrollTop.value) {
					document.body.classList.remove('scroll-down')

					if (myParam) {
						document.body.classList.remove('scroll-up')
						document.body.classList.add('scroll-about')
					} else {
						document.body.classList.remove('scroll-about')
						document.body.classList.add('scroll-up')
					}
				}
				lastScrollTop.value = st
			}

			onMounted(() => {
				document.addEventListener('scroll', handleScroll)
			})

			onUnmounted(() => {
				document.removeEventListener('scroll', handleScroll)
			})

			const {
				proxy: { $emitter },
			} = getCurrentInstance()
			const pageWrapper = ref(null)
			const isReady = ref(false)
			const pageScrollTop = ref(0)
			const scrollHandlerCount = ref(0)
			const visibleComponentId = ref('creator-store')
			const callToActionButtonText = ref('Create Your Store')
			const isMobile = ref(getIsMobile())

			const lastScrollTop = ref(0)
			const isScrollingUp = ref(false)
			const isScrollingDown = ref(false)

			const scrollHandler = ev => {
				if (scrollHandlerCount.value % 5 === 0) {
					let component
					for (let componentId of Object.keys(callToActionButton)) {
						component = document.getElementById(componentId)
						if (component) {
							try {
								const inViewPort = isInView(isMobile.value, component)
								if (inViewPort) {
									visibleComponentId.value = componentId
									document.documentElement.style.setProperty(
										'--stan-fixed-button-background',
										callToActionButton[componentId].background
									)
									document.documentElement.style.setProperty('--stan-fixed-button-color', callToActionButton[componentId].color)

									callToActionButtonText.value = callToActionButton[componentId].text
									break
								}
							} catch (err) {
								console.error(err)
							}
						} else {
							console.log(`can't not get component: ${componentId}`)
						}
					}
				}
				scrollHandlerCount.value = (scrollHandlerCount.value + 1) % 5
			}

			const registerByEvent = msg => {
				$emitter.emit('register', msg)
			}
			const signIn = msg => {
				$emitter.emit('sign.in', msg)
			}

			onMounted(() => {
				setTimeout(() => {
					pageWrapper.value.scrollTo(0, 0)
					nextTick(() => {
						isReady.value = true
					})
				}, 500)
			})

			watch(isMobile, val => {
				if (val && visibleComponentId.value === 'creator-store') {
					pageWrapper.value.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
				}
			})
			if (typeof window.clarity === 'function') {
				window.clarity('set', 'version', 'v6')
			}

			onUnmounted(() => {
				pageWrapper.value?.removeEventListener('scroll', scrollHandler, false)
			})

			return {
				pageWrapper,
				isReady,
				visibleComponentId,
				callToActionButtonText,
				isScrollingUp,
				isScrollingDown,
				registerByEvent,
				signIn,
			}
		},
	})
</script>

<style lang="scss">
	body {
		overflow-x: hidden !important;
		background-color: #6355ff;
	}

	.scroll-up {
		background-color: #6355ff !important;
	}

	.scroll-about {
		background-color: black !important;
	}

	.scroll-down {
		background-color: #f2f4f8 !important;
	}

	html.page-version {
		width: 100vw;
		overflow-x: hidden !important;

		body {
			width: 100vw;
			overflow-x: hidden !important;
			-ms-overflow-style: none; /* for Internet Explorer, Edge */
			scrollbar-width: 0;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		::-webkit-scrollbar {
			width: 0 !important;
		}

		.page-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
			overflow: hidden;
		}

		.landing-page-component {
			width: 100vw;
			height: fit-content !important;
		}
	}
</style>
